import React, { useEffect } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { FormFeedback, Input } from 'reactstrap';
import Select from 'react-select';
import { useDispatch, useSelector } from 'react-redux';
import toast from 'react-hot-toast';
import {
	useFeaturedPlayListByIdQuery,
	useGetVideosListQuery,
	useSubmitFeaturedPlayListMutation
} from '../../../../../service';
import { getVideoDropDownList } from '../../../../../redux/videoSlice';

function FeaturedPlayListForm({ show, setShow, editPlaylistID }) {
	const dispatch = useDispatch();

	// API queries and mutations
	const [reqFeatured, resFeatured] = useSubmitFeaturedPlayListMutation();
	const videoDropdownList = useSelector(state => state.videoState.videoDropdownList);
	const resVideo = useGetVideosListQuery();
	const resGetById = useFeaturedPlayListByIdQuery(editPlaylistID, {
		skip: !editPlaylistID
	});

	// Form setup
	const {
		control,
		handleSubmit,
		formState: { errors },
		reset,
		setValue
	} = useForm();

	// Initialize form with existing data when editing
	useEffect(() => {
		if (resGetById?.isSuccess && resGetById?.data?.existingVideos) {
			const playlist = resGetById.data.existingVideos;
			reset({
				createdAt: playlist.createdAt,
				description: playlist.description,
				name: playlist.name,
				videos: playlist.videos,
				id: playlist._id
			});
		}
	}, [resGetById?.isSuccess, reset]);

	// Update video dropdown options when video list changes
	useEffect(() => {
		if (resVideo?.isSuccess && resVideo?.data) {
			const videoOptions = resVideo.data.map(video => ({
				...video,
				label: video.title,
				value: video.title
			}));
			dispatch(getVideoDropDownList(videoOptions));
		}
	}, [resVideo, dispatch]);

	// Handle form submission
	const onSubmit = data => {
		reqFeatured(data);
	};

	// Handle API response
	useEffect(() => {
		if (resFeatured?.isSuccess) {
			toast.success('Featured playlist saved successfully', {
				position: 'top-center',
				duration: 3000
			});
			setShow(false);
		}

		if (resFeatured?.isError) {
			toast.error('Something went wrong', {
				position: 'top-center',
				duration: 3000
			});
		}
	}, [resFeatured, setShow]);

	return (
		<section className="">
			<div className="container">
				<div className="c-sing_form-bo">
					<form onSubmit={handleSubmit(onSubmit)}>
						<div className="row g-2">
							{/* Playlist Name */}
							<div className="col-md-12 form-group">
								<Controller
									name="name"
									control={control}
									rules={{ required: 'Name is required' }}
									render={({ field }) => (
										<Input placeholder="Enter Name" className="form-control name" {...field} type="text" />
									)}
								/>
								{errors.name && <FormFeedback>{errors.name.message}</FormFeedback>}
							</div>

							{/* Description */}
							<div className="col-md-12 form-group">
								<Controller
									name="description"
									control={control}
									rules={{ required: 'Description is required' }}
									render={({ field }) => (
										<textarea placeholder="Enter description" className="form-control h-auto" {...field} />
									)}
								/>
								{errors.description && <FormFeedback>{errors.description.message}</FormFeedback>}
							</div>

							{/* Video Selection */}
							<div className="col-md-12 form-group">
								<Controller
									name="videos"
									control={control}
									rules={{ required: 'Video is required' }}
									render={({ field: { onChange, value } }) => (
										<Select
											isMulti
											isClearable
											options={videoDropdownList || []}
											className="react-select"
											classNamePrefix="select"
											placeholder="Select videos"
											onChange={onChange}
											value={value ? value : null}
										/>
									)}
								/>
								{errors.videos && <FormFeedback>{errors.videos.message}</FormFeedback>}
							</div>

							{/* Submit Button */}
							<div className="col-md-12 form-group text-end action__btns">
								<button type="submit" className="btn btn-primary px-4 px-md-5">
									Save
								</button>
							</div>
						</div>
					</form>
				</div>
			</div>
		</section>
	);
}

export default FeaturedPlayListForm;
